import { render, staticRenderFns } from "./tm-checkbox.vue?vue&type=template&id=2a81484e&scoped=true&"
import script from "./tm-checkbox.vue?vue&type=script&lang=ts&"
export * from "./tm-checkbox.vue?vue&type=script&lang=ts&"
import style0 from "./tm-checkbox.vue?vue&type=style&index=0&id=2a81484e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a81484e",
  null
  
)

export default component.exports